/* eslint-disable react-hooks/refs -- refs are only used as reaction if the hook is already executing, never to signal changes to consuming components */
import { DependencyList, EffectCallback, useEffect, useMemo, useRef } from 'react';
import { isEqual } from 'lodash';

export const useEffectDeepCompare = (effect: EffectCallback, deps?: DependencyList): ReturnType<typeof useEffect> => {
  const depsRef = useRef(deps);
  const changeCounterRef = useRef(0);

  if (!isEqual(deps, depsRef.current)) {
    // console.log(deps, depsRef.current);
    depsRef.current = deps;
    changeCounterRef.current++;
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedDeps = useMemo(() => depsRef.current, [changeCounterRef.current]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect, memoizedDeps);
};
